import { render, staticRenderFns } from "./TestVideoOneResult.vue?vue&type=template&id=60deadff&scoped=true&"
import script from "./TestVideoOneResult.vue?vue&type=script&lang=js&"
export * from "./TestVideoOneResult.vue?vue&type=script&lang=js&"
import style0 from "./TestVideoOneResult.vue?vue&type=style&index=0&id=60deadff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60deadff",
  null
  
)

export default component.exports